{
  "MFA_SETTINGS": {
    "TITLE": "Двухфакторная аутентификация",
    "SUBTITLE": "Protect your account from unauthorized access with TOTP-based authentication. This adds an extra layer of security to your account.",
    "DESCRIPTION": "Добавьте дополнительный уровень безопасности для вашего аккаунта, используя одноразовый пароль (TOTP)",
    "STATUS_TITLE": "Статус аутентификации",
    "STATUS_DESCRIPTION": "Управление настройками двухфакторной аутентификации и резервными кодами",
    "ENABLED": "Включено",
    "DISABLED": "Выключено",
    "STATUS_ENABLED": "Двухфакторная аутентификация активна",
    "STATUS_ENABLED_DESC": "Ваша учетная запись защищена дополнительным уровнем безопасности",
    "ENABLE_BUTTON": "Включить двухфакторную аутентификацию",
    "ENHANCE_SECURITY": "Улучшите безопасность аккаунта",
    "ENHANCE_SECURITY_DESC": "Двухфакторная аутентификация добавляет дополнительный уровень безопасности, требуя проверочный код от вашего приложения аутентификатора в дополнение к вашему паролю.",
    "SETUP": {
      "STEP_NUMBER_1": "1",
      "STEP_NUMBER_2": "2",
      "STEP1_TITLE": "Отсканируйте QR-код с помощью приложения аутентификатора",
      "STEP1_DESCRIPTION": "Используйте Google Authenticator, Authy, или любое TOTP-совместимое приложение",
      "LOADING_QR": "Загрузка...",
      "MANUAL_ENTRY": "Не можете отсканировать? Введите код вручную",
      "SECRET_KEY": "Секретный ключ",
      "COPY": "Копировать",
      "ENTER_CODE": "Введите 6-значный код из вашего приложения аутентификации",
      "ENTER_CODE_PLACEHOLDER": "000000",
      "VERIFY_BUTTON": "Проверить и продолжить",
      "CANCEL": "Отменить",
      "ERROR_STARTING": "MFA не включена. Пожалуйста, свяжитесь с администратором.",
      "INVALID_CODE": "Неверный код подтверждения",
      "SECRET_COPIED": "Секретный ключ скопирован в буфер обмена",
      "SUCCESS": "Двухфакторная аутентификация была успешно включена"
    },
    "BACKUP": {
      "TITLE": "Сохранить резервные коды",
      "DESCRIPTION": "Храните эти коды в безопасности. Каждый может быть использован один раз, если вы потеряете доступ к вашему аутентификатору",
      "IMPORTANT": "Важно:",
      "IMPORTANT_NOTE": " Храните эти коды в безопасном месте. Вы не сможете их снова увидеть.",
      "DOWNLOAD": "Скачать",
      "COPY_ALL": "Скопировать все",
      "CONFIRM": "Я сохранил свои резервные коды в безопасном месте и понимаю, что я не смогу снова их увидеть",
      "COMPLETE_SETUP": "Завершить установку",
      "CODES_COPIED": "Резервные коды скопированы в буфер обмена"
    },
    "MANAGEMENT": {
      "BACKUP_CODES": "Резервные коды",
      "BACKUP_CODES_DESC": "Сгенерировать новые коды, если вы потеряли или использовали существующие",
      "REGENERATE": "Пересоздать резервные коды",
      "DISABLE_MFA": "Отключить 2FA",
      "DISABLE_MFA_DESC": "Удалить двухфакторную аутентификацию из вашей учетной записи",
      "DISABLE_BUTTON": "Отключить двухфакторную аутентификацию"
    },
    "DISABLE": {
      "TITLE": "Отключить двухфакторную аутентификацию",
      "DESCRIPTION": "Вам необходимо ввести пароль и проверочный код, чтобы отключить двухфакторную аутентификацию.",
      "PASSWORD": "Пароль",
      "OTP_CODE": "Проверочный код",
      "OTP_CODE_PLACEHOLDER": "000000",
      "BACKUP_CODE": "Резервные код",
      "BACKUP_CODE_PLACEHOLDER": "Введите один из ваших резервных кодов",
      "USE_BACKUP_CODE": "Потеряли доступ к вашему аутентификатору? Используйте вместо этого резервный код",
      "USE_OTP_CODE": "Используйте проверочный код из вашего приложения-аутентификатора",
      "CONFIRM": "Отключить 2FA",
      "CANCEL": "Отменить",
      "SUCCESS": "Двухфакторная аутентификация была отключена",
      "ERROR": "Не удалось отключить MFA. Проверьте ваши учетные данные."
    },
    "REGENERATE": {
      "TITLE": "Пересоздать резервные коды",
      "DESCRIPTION": "Это приведет к аннулированию существующих резервных кодов и созданию новых. Введите код подтверждения для продолжения.",
      "OTP_CODE": "Проверочный код",
      "OTP_CODE_PLACEHOLDER": "000000",
      "CONFIRM": "Сгенерировать новые коды",
      "CANCEL": "Отменить",
      "NEW_CODES_TITLE": "Новые резервные коды созданы",
      "NEW_CODES_DESC": "Ваши старые резервные коды были аннулированы. Сохраните эти новые коды в безопасном месте.",
      "CODES_IMPORTANT": "Важно:",
      "CODES_IMPORTANT_NOTE": " Каждый код может быть использован только один раз. Сохраните их перед закрытием этого окна.",
      "DOWNLOAD_CODES": "Скачать коды",
      "COPY_ALL_CODES": "Копировать все коды",
      "CODES_SAVED": "Я сохранил мои коды",
      "SUCCESS": "Новые резервные коды были созданы",
      "ERROR": "Не удалось пересоздать резервные коды"
    }
  },
  "MFA_VERIFICATION": {
    "TITLE": "Двухфакторная аутентификация",
    "DESCRIPTION": "Введите код подтверждения, чтобы продолжить",
    "AUTHENTICATOR_APP": "Приложение аутентификатор",
    "BACKUP_CODE": "Резервные код",
    "ENTER_OTP_CODE": "Введите 6-значный код из вашего приложения аутентификатора",
    "ENTER_BACKUP_CODE": "Введите один из ваших резервных кодов",
    "BACKUP_CODE_PLACEHOLDER": "000000",
    "VERIFY_BUTTON": "Проверить",
    "TRY_ANOTHER_METHOD": "Попробуйте другой способ подтверждения",
    "CANCEL_LOGIN": "Отменить и вернуться к входу",
    "HELP_TEXT": "Проблемы с входом?",
    "LEARN_MORE": "Узнайте больше о 2FA",
    "HELP_MODAL": {
      "TITLE": "Справка по двухфакторной аутентификации",
      "AUTHENTICATOR_TITLE": "Использовать приложение для аутентификации",
      "AUTHENTICATOR_DESC": "Откройте ваше приложение аутентификатор (Google Authenticator, Authy и т. д.) и введите 6-значный код, показанный для вашей учетной записи.",
      "BACKUP_TITLE": "Использовать код резервной копии",
      "BACKUP_DESC": "Если у вас нет доступа к приложению для аутентификации, вы можете использовать один из резервных кодов, сохраненных при настройке 2FA. Каждый код может быть использован только один раз.",
      "CONTACT_TITLE": "Нужна помощь?",
      "CONTACT_DESC_CLOUD": "Если вы потеряли доступ к приложению для аутентификации и резервным кодам, пожалуйста, обратитесь в службу поддержки Chatwoot.",
      "CONTACT_DESC_SELF_HOSTED": "Если вы потеряли доступ к приложению для аутентификации и резервным кодам, обратитесь к администратору за помощью."
    },
    "VERIFICATION_FAILED": "Проверка не удалась. Пожалуйста, попробуйте еще раз."
  }
}
